/** Etiquetas UI para tipo_usuario (0 = salud, 1 = administrativo). Valores BD sin cambio. */

export const TIPO_USUARIO_SALUD = '0';
export const TIPO_USUARIO_ADMIN = '1';

export const TIPO_USUARIO_LABEL = {
    [TIPO_USUARIO_SALUD]: 'Personal de la Salud',
    [TIPO_USUARIO_ADMIN]: 'Personal Administrativo',
};

export const TIPO_USUARIO_LABEL_CORTO = {
    [TIPO_USUARIO_SALUD]: 'P. Salud',
    [TIPO_USUARIO_ADMIN]: 'P. Administrativo',
};

export const TIPO_USUARIO_DESC = {
    [TIPO_USUARIO_SALUD]: 'Acceso a historial clínico, agenda de citas, diagnósticos y tratamientos de pacientes.',
    [TIPO_USUARIO_ADMIN]: 'Acceso a facturación, gestión de citas, configuración del sistema y reportes administrativos.',
};

export const CUPOS_SALUD = 'Cupos P. Salud';
export const CUPOS_ADMIN = 'Cupos P. Administrativo';

export function labelTipoUsuario(tipo, corto = false) {
    const key = String(tipo ?? '');
    const map = corto ? TIPO_USUARIO_LABEL_CORTO : TIPO_USUARIO_LABEL;
    return map[key] ?? key;
}
